module.exports = __webpack_public_path__ + "static/index/img/quit.7e14bb3f.png";